
import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Define global interface for existing lagacy code support
declare global {
    interface Window {
        FazendaRP: {
            supabase?: SupabaseClient | null;
            Pages?: any;
            renderHeader?: (container: HTMLElement | null) => void;
            renderNav?: (container: HTMLElement | null) => void;
            [key: string]: any;
        };
    }
}

// Configuração do Supabase usando Variáveis de Ambiente do Vite
const PROJECT_URL = import.meta.env.VITE_SUPABASE_URL;
const ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!PROJECT_URL || !ANON_KEY) {
    console.error('❌ ERRO CRÍTICO: Variáveis de ambiente do Supabase não encontradas!');
    console.error('Verifique se .env.local existe e contem VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY');
}

// Inicializa global
window.FazendaRP = window.FazendaRP || {};

// Inicializa Cliente Seguro
export const supabase = createClient(PROJECT_URL, ANON_KEY);

// Mantém compatibilidade global para scripts legados
window.FazendaRP.supabase = supabase;

console.log('✅ Supabase conectado via módulo seguro (Vite)');
